import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import React, { Fragment, lazy, useState, useEffect } from 'react';
import { FormStateChangeNotifier } from '../form';
import { FieldContainer } from '../../UIKit-legacy/utils/FieldContainer';
var AKDatePicker = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.datetime-picker' */
  '@atlaskit/datetime-picker').then(function (module) {
    return {
      default: module.DatePicker
    };
  });
});
var AKField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var AKHelperMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.HelperMessage
    };
  });
});
var AKErrorMessage = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.ErrorMessage
    };
  });
});
var validate = function validate(value) {
  return !value ? 'EMPTY' : undefined;
};
export var getDateFormat = function getDateFormat(locale) {
  var formatObj = new Intl.DateTimeFormat(locale).formatToParts(new Date());
  return formatObj.map(function (obj) {
    switch (obj.type) {
      case 'day':
        return 'DD';
      case 'month':
        return 'MM';
      case 'year':
        return 'YYYY';
      default:
        return obj.value;
    }
  }).join('');
};
var DatePicker = function DatePicker(_ref) {
  var name = _ref.name,
    label = _ref.label,
    description = _ref.description,
    placeholder = _ref.placeholder,
    defaultValue = _ref.defaultValue,
    isRequired = _ref.isRequired;
  var _useState = useState('en-US'),
    _useState2 = _slicedToArray(_useState, 2),
    locale = _useState2[0],
    setLocale = _useState2[1];
  useEffect(function () {
    if (window.navigator.languages && locale !== window.navigator.languages[0]) {
      setLocale(window.navigator.languages[0]);
    }
  }, [locale]);
  return jsx(FieldContainer, null, jsx(AKField, {
    name: name,
    label: label,
    defaultValue: defaultValue,
    isRequired: isRequired,
    validate: isRequired ? validate : undefined
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps,
      error = _ref2.error;
    var _ref3 = fieldProps,
      id = _ref3.id,
      isDisabled = _ref3.isDisabled,
      isInvalid = _ref3.isInvalid,
      onBlur = _ref3.onBlur,
      onChange = _ref3.onChange,
      onFocus = _ref3.onFocus,
      ariaInvalid = _ref3['aria-invalid'],
      ariaLabelledBy = _ref3['aria-labelledby'];
    return jsx(Fragment, null, jsx(FormStateChangeNotifier, {
      name: name,
      value: fieldProps.value
    }), jsx(AKDatePicker, {
      id: id,
      isDisabled: isDisabled,
      onBlur: onBlur,
      onFocus: onFocus,
      onChange: onChange,
      value: fieldProps.value || '',
      placeholder: placeholder,
      dateFormat: getDateFormat(locale),
      isInvalid: isInvalid || Boolean(error),
      "aria-invalid": ariaInvalid,
      "aria-labelledby": ariaLabelledBy
    }), error === 'EMPTY' && jsx(AKErrorMessage, null, "This field is required."), description && jsx(AKHelperMessage, null, description));
  }));
};
export default DatePicker;
export var DatePickerFn = function DatePickerFn(_ref4) {
  var props = _ref4.props;
  var _ref5 = props,
    name = _ref5.name,
    label = _ref5.label,
    defaultValue = _ref5.defaultValue,
    description = _ref5.description,
    placeholder = _ref5.placeholder,
    isRequired = _ref5.isRequired;
  return jsx(DatePicker, {
    name: name,
    label: label,
    defaultValue: defaultValue,
    description: description,
    placeholder: placeholder,
    isRequired: isRequired
  });
};